import InvoiceStatusAvatar from './InvoiceStatusAvatar';

export default InvoiceStatusAvatar;
